import React from "react";
import verticalSpacing from "helpers/generate-vertical-spacing";

const Iframe = ({ url, title, className, settings, ...other }) => {
    const {verticalSpace} = settings;
    return (
        <div className={`flex justify-center px-4 ${verticalSpacing(
            verticalSpace
          )}`}>
            <iframe src={url} title={title} {...other} className="xsm:w-[90%] xsm:h-[400px]" />
        </div>
    )
};

export default Iframe;